import {CSSProperties} from "react";
import {DATE_PICKER_HORIZONTAL_DIVIDER} from "../../../../../../styles/colors";

const verticalSearchbarDividerStyle: CSSProperties = {
  width: '1px',
  height: '30px',
  borderRadius: '1px',
  backgroundColor: DATE_PICKER_HORIZONTAL_DIVIDER
}

export const styles = {
  VerticalSearchbarDivider: verticalSearchbarDividerStyle,
}